<template>
	<div class="wrap wrap_business">
		<div v-if="props.data.main_business.business" class="chart_box">
			<h2 class="report_title">주요사업</h2>
			<BusinessChartItemKR
				v-if="props.data.main_business.business.length > 0"
				:data="props.data.main_business.business"
			/>
			<div v-else class="emptyData_alert">데이터 없음</div>
		</div>
		<div
			v-if="!(props.data.main_business.introduction === '<p></p>' || !props.data.main_business.introduction)"
			class="description_box"
		>
			<h2 class="report_title">주요사업 소개</h2>
			<div
				v-dompurify-html="props.data.main_business.introduction"
				class="c_editorContent c_editorContent_outline"
			></div>
		</div>
		<div
			v-if="
				props.data.event_governance_structure.governance_structure
					.map((item) => item.event_governance_structure_take)
					.reduce((a, b) => a + b, 0) > 0
			"
			class="chart_box"
		>
			<h2 class="report_title">지배구조</h2>
			<BusinessChartItemKR
				v-if="props.data.event_governance_structure.governance_structure.length > 0"
				:data="props.data.event_governance_structure.governance_structure"
			/>
			<div v-else class="emptyData_alert">데이터 없음</div>
		</div>
		<div
			v-if="
				!(
					props.data.event_governance_structure.introduction === '<p></p>' ||
					!props.data.event_governance_structure.introduction
				)
			"
			class="description_box"
		>
			<h2 class="report_title">지배구조 소개</h2>
			<div
				v-dompurify-html="props.data.event_governance_structure.introduction"
				class="c_editorContent c_editorContent_outline"
			></div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { InvestReportBusinessData_KR } from '@/api/report';
import BusinessChartItemKR from '@/components/report/kr/BusinessChartItemKR.vue';

const props = defineProps<{
	data: InvestReportBusinessData_KR;
}>();
</script>

<style scoped lang="scss">
.wrap_business {
	.report_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-bold);
		line-height: 2.387rem;
	}
	.chart_box {
		display: flex;
		flex-direction: column;
		gap: 2.4rem;
	}
	.description_box {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
}
.emptyData_alert {
	padding: 3.2rem 0rem;
	font-size: var(--font-s-regular);
	font-weight: var(--font-w-light);
	line-height: 1.2;
	text-align: center;
}
</style>
